import { gql } from '@apollo/client';

export const ApplyWeightedRdPercentageToExpensesResultFragment = gql`
  fragment ApplyWeightedRdPercentageToExpensesResult on ApplyWeightedRdPercentageToExpensesResult {
    success
  }
`;
